import React from 'react';
import classNames from 'classnames';
import ContentLoader from 'react-content-loader';

import './ReplySuggestionsPlaceholder.styles.scss';

const PLACEHOLDER_WIDTHS = [152, 122, 166];

type ReplySuggestionsPlaceholderProps = {
  className?: string;
};

const ReplySuggestionsPlaceholder: React.FC<
  ReplySuggestionsPlaceholderProps
> = (props) => {
  const { className } = props;

  const classes = classNames('reply-suggestions-placeholder', className);

  return (
    <div className={classes}>
      {PLACEHOLDER_WIDTHS.map((width, i) => (
        <ContentLoader
          className="reply-suggestions-placeholder__placeholder"
          key={i}
          style={{ width: `${width}px` }}
          backgroundColor="#e7f1fc"
          foregroundColor="#ffffff"
          preserveAspectRatio="none"
        >
          <rect x="0" y="0" rx="16" ry="16" width="100%" height="100%" />
        </ContentLoader>
      ))}
    </div>
  );
};

export default ReplySuggestionsPlaceholder;
